import axios from 'axios';

let _logoutFn = null;

export const registerLogout = (fn) => {
    _logoutFn = fn;
};

const getCsrfTokenFromCookie = () => {
    const cookies = document.cookie.split('; ');
    const csrfCookie = cookies.find(row => row.startsWith('csrf_token='));
    return csrfCookie ? csrfCookie.split('=')[1] : null;
};

const api = axios.create({
    baseURL: 'https://shop.mulsolgroup.com/api',
    // baseURL: 'http://localhost:8286/api', // local
    // baseURL: 'http://10.151.76.62:3000/api',
    
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const method = config.method?.toUpperCase();

    if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
        const csrfToken = getCsrfTokenFromCookie();
        if (csrfToken) {
            config.headers['X-CSRF-Token'] = csrfToken;
        }
    }

    return config;
});

api.interceptors.response.use(
    (response) => response.data,
    async (error) => {
        const status = error.response?.status;
        const data = error.response?.data;
        const url = error.config?.url || '';

        if (error.config?.skipAuthRedirect) {
            return Promise.reject(data ?? error);
        }

        const isPasswordChange =
            url.includes('change-password') ||
            url.includes('changePassword') ||
            error.config?.headers?.['X-Password-Change'] === 'true';

        if (status === 401) {
            if (isPasswordChange) {
                return Promise.reject(error);
            }

            if (!window.location.pathname.includes('/login')) {
                if (_logoutFn) {
                    try { await _logoutFn(); } catch { /* ignore */ }
                }
                window.location.href = '/login';
            }
            return Promise.reject(data ?? error);
        }

        if (status === 403) {
            if (isPasswordChange) {
                return Promise.reject(error);
            }

            if (data?.message?.includes('CSRF') || data?.message?.includes('csrf')) {
                if (!window.location.pathname.includes('/login')) {
                    if (_logoutFn) {
                        try { await _logoutFn(); } catch { /* ignore */ }
                    }
                    window.location.href = '/login';
                }
            }
            return Promise.reject(data ?? error);
        }

        if (status === 422) {
            return Promise.reject({
                status: 'error',
                message: 'Validation failed',
                errors: data?.errors || data,
            });
        }

        return Promise.reject(data ?? error);
    }
);

export default api;